import { ListConfigs } from '../../app/sharedComponent/SearchList/SearchList.types'
import { filterConfig } from '../Global.types'
export const SMARTDOCSLISTCONFIGS: ListConfigs[] = [
    {
        headerName: 'Document Name',
        apiFieldName: 'documentName',
        type: 'TEXT',
        columnWidth: '150',
    },
    {
        headerName: 'Document Type',
        apiFieldName: 'documentTypes',
        type: 'MULTILEVEL_TEXT',
        secondLevelKey: 'documentType',
        columnWidth: '150',
    },
    {
        headerName: 'Language',
        apiFieldName: 'language',
        secondLevelKey: 'languageName',
        type: 'TEXT',
        columnWidth: '100',
    },
    {
        headerName: 'Contract Type',
        apiFieldName: 'contractType',
        secondLevelKey: 'name',
        type: 'MULTILEVEL_TEXT',
        columnWidth: '100',
    },
    {
        headerName: 'Customer Type',
        apiFieldName: 'customerType',
        type: 'MULTILEVEL_TEXT',
        secondLevelKey: 'name',
        columnWidth: '150',
    },
    {
        headerName: 'State ',
        apiFieldName: 'stateDetail',
        type: 'MULTILEVEL_TEXT',
        secondLevelKey: 'name',
        columnWidth: '100',
    },
    {
        headerName: 'Utility  ',
        apiFieldName: 'utility',
        secondLevelKey: 'name',
        type: 'MULTILEVEL_TEXT',
        columnWidth: '100',
    },
    {
        headerName: 'Commodity  ',
        apiFieldName: 'commodity',
        secondLevelKey: 'name',
        type: 'MULTILEVEL_TEXT',
        columnWidth: '100',
    },
    {
        headerName: 'Product',
        apiFieldName: 'smartDocProducts',
        type: 'DROPDOWN_COMMA_SEPERATED',
        columnWidth: '100',
    },
    {
        headerName: 'Status ',
        apiFieldName: 'isActive',
        type: 'ACTIVE_BADGE',
        columnWidth: '100',
    },
]

export type DocsSetupEnumType =
    | 'STATE'
    | 'UTILITY'
    | 'COMMODITY'
    | 'DOCUMENT_STATUS'
    | 'CONTRACT_TYPE'


const map = (data: productFilterDataFeedNames[]) => data.map(({ value, id }) => ({ value: id, name: value }))

export const filterDataFeedHelper: (
    data: productFilterDataFeedNames[],
    enumType: DocsSetupEnumType
) => filterConfig = (data: productFilterDataFeedNames[], enumType: DocsSetupEnumType) => {
    switch (enumType) {
        case 'STATE':
            return { key: 'State', label: 'State', type: 'STRING', options: map(data) }

        case 'UTILITY':
            return { key: 'utilityId', label: 'Utility', type: 'STRING', options: map(data) }

        case 'CONTRACT_TYPE':
            return { key: 'ContractTypeId', label: 'Contract Type', type: 'STRING', options: map(data) }

        case 'COMMODITY':
            return { key: 'Commodity', label: 'Commodity', type: 'STRING', options: map(data) }

        case 'DOCUMENT_STATUS':
            return {
                key: 'documentStatus',
                label: 'Document Status',
                type: 'STRING',
                options: map(data),
            }

        default:
            return {
                key: '',
                label: '',
                type: 'STRING',
                options: [],
            }
    }
}
export type smartDocsFilterType = {
    enum: DocsSetupEnumType
    names: productFilterDataFeedNames[]
}
export type productFilterDataFeedNames = {
    id: string
    value: string
}
